import { createModule } from '@Actions/utils';
import { SERVICE_ENDPOINT } from '@Apis/constants';

const CreateInProcessQC = createModule({
  base: 'CREATE_IN_PROCESS_QUALITY_CONTROL_RULE',
  apiDetails: { ...SERVICE_ENDPOINT.IN_PROCESS_QUALITY_CONTROL_RULE, method: 'post' },
  errors: { defaultError: true, customError: '' },
  enableNotification: true,
});

const UpdateInProcessQC = createModule({
  base: 'UPDATE_IN_PROCESS_QUALITY_CONTROL_RULE',
  apiDetails: { ...SERVICE_ENDPOINT.IN_PROCESS_QUALITY_CONTROL_RULE, method: 'put' },
  errors: { defaultError: true, customError: '' },
  enableNotification: true,
});

const GetInProcessQC = createModule({
  base: 'GET_IN_PROCESS_QUALITY_CONTROL_RULE',
  apiDetails: { ...SERVICE_ENDPOINT.IN_PROCESS_QUALITY_CONTROL_RULE, method: 'get' },
  errors: { defaultError: true, customError: '' },
});

const DeleteInProcessQC = createModule({
  base: 'DELETE_IN_PROCESS_QUALITY_CONTROL_RULE',
  apiDetails: { ...SERVICE_ENDPOINT.IN_PROCESS_QUALITY_CONTROL_RULE, method: 'delete' },
  errors: { defaultError: true, customError: '' },
  enableNotification: true,
});

export {
  CreateInProcessQC,
  UpdateInProcessQC,
  GetInProcessQC,
  DeleteInProcessQC,
};
